import { createSlice } from '@reduxjs/toolkit'
import Config from '../../Core/Config'

export const SET_SELECTED_VEHICLE_COMPONENTS = 'ui/vehiclecomponents/setSelected'
export const UNSELECT_VEHICLE_COMPONENT = 'ui/vehiclecomponents/unselect'
export const ACTIVATE_SHORTCUT = 'ui/vehiclecomponents/activateShortcut'
export const DISACTIVATE_SHORTCUT = 'ui/vehiclecomponents/disactivateShortcut'

const vehicleComponentsUiSlice = createSlice({
  name: 'vehicleComponents',
  initialState: {
    selectedVehicleComponents: [],
    activeShortcut: null,
    menu: {
      expanded: Config.ui.defaultExpandedRightMenu,
    },
  },
  reducers: {
    init: (state) => {
      return { ...state, initing: true }
    },
    setSelectedVehicleComponents: (state, action) => {
      state.selectedVehicleComponents = action.payload
    },
    unselectVehicleComponent: (state, action) => {
      state.selectedVehicleComponents = state.selectedVehicleComponents.filter((tc) => tc.id !== action.payload.id)
    },
    activateShortcut: (state, action) => {
      state.activeShortcut = action.payload
    },
    disactivateShortcut: (state) => {
      state.activeShortcut = null
    },
    toggleMenuExpanded: (state) => {
      state.menu.expanded = !state.menu.expanded
    },
  },
})

export const {
  setSelectedVehicleComponents,
  unselectVehicleComponent,
  activateShortcut,
  disactivateShortcut,
  toggleMenuExpanded,
} = vehicleComponentsUiSlice.actions
export default vehicleComponentsUiSlice.reducer

export const selectSelectedVehicleComponents = (state) => state.ui.vehicleComponents.selectedVehicleComponents
export const selectActiveShorcut = (state) => state.ui.vehicleComponents.activeShortcut
export const selectMenuExpanded = (state) => state.ui.vehicleComponents.menu.expanded
